import { ButtonContainer, Buttons } from "../../../generic-sprites/Buttons"
import { Rectangle } from "../../../generic-sprites/Shape"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { MakeAVideoState } from "../MakeAVideoState"
import { MakeAVideoStore } from "../MakeAVideoStore"
import { MakeVideoAudio } from "../MakeVideoAssets"
import { MakeVideoSprite, MakeVideoSpriteContainer } from "../MakeVideoTypes"

interface TitleInfo {
    title: string
    audio: string
}

export class MakeVideoTitleSelectContainer implements MakeVideoSprite, MakeVideoSpriteContainer {

    private static titles: Array<TitleInfo> = [
        {title: "The Unpopular Smoker", audio: MakeVideoAudio.UNPOPULAR_SMOKER},
        {title: "The Stupid Smoker", audio: MakeVideoAudio.STUPID_SMOKER},
        {title: "Uncool Smoker Dude", audio: MakeVideoAudio.UNCOOL_SMOKER_DUDE},
        {title: "Uncool Singing Smoker", audio: MakeVideoAudio.UNCOOL_SINGING_SMOKER},
        {title: "Unpopular Smoker Dude", audio: MakeVideoAudio.UNPOPULAR_SMOKER_DUDE},
        {title: "Stupid Singing Smoker", audio: MakeVideoAudio.STUPID_SINGING_SMOKER},
    ]

    active: boolean
    choices: Array<MakeVideoTitleChoice>

    constructor(
        game: Phaser.Game,
        group: Phaser.Group,
        x: number,
        y: number,
        private nextButton: ButtonContainer,
        private edit: boolean,
        moveToStep: () => void
    ) {
        let currentY = y
        this.choices = MakeVideoTitleSelectContainer.titles.map(title => {
            const onClick = () => {
                game.sound.stopAll()
                this.choices.filter(c => c.title !== title.title).forEach(c => c.selected = false)
                game.add.audio(title.audio).play()
                nextButton.enable()
            }
            const choice = new MakeVideoTitleChoice(game, title.title, onClick, group, x, currentY)
            currentY += choice.outline.invisibleSprite.height + Scale.y(0.01)
            return choice
        })

        if (edit) {
            const [choice] = this.choices.filter(c => c.title === MakeAVideoStore.instance.title)
            choice.selected = true
        }

        this.active = true

        MakeAVideoState.debugPanel.setSkip(() => {
            game.sound.stopAll()
            moveToStep()
            MakeAVideoStore.instance.title = MakeVideoTitleSelectContainer.titles[0].title
        })
    }

    disableAll = () => this.choices.forEach(choice => choice.disable())

    enableAll = () => {
        this.choices.forEach(choice => choice.enable())
        if (this.edit) {
            this.nextButton.enable()
        }
    }

    destroy = () => {
        this.choices.forEach(choice => choice.destroy())
        this.active = false
    }
}

class MakeVideoTitleChoice implements MakeVideoSprite {
    active: boolean
    outline: Rectangle
    private readonly titleSprite: Phaser.Text

    constructor(
        game: Phaser.Game,
        public title: string,
        private onClick: () => void,
        group: Phaser.Group,
        x: number,
        y: number
    ) {
        this.titleSprite = PhaserText.create(game, title)
        this.outline = new Rectangle(game, x, y, Scale.x(0.4), Scale.y(0.08), {
            lineColor: Phaser.Color.RED,
            lineWidth: 5,
            group
        })
        Sprites.centerInWorldXOnly(this.outline.invisibleSprite)
        Sprites.centerInWorldXOnly(this.outline.graphics)
        Sprites.centerTextInSprite(this.outline.invisibleSprite, this.titleSprite)

        this.enable()
        this.selected = false
        this.active = true
    }

    set selected(visible: boolean) {
        this.outline.graphics.visible = visible
    }

    disable = () => {
        Buttons.undoSpriteButton(this.outline.invisibleSprite)
        Buttons.undoSpriteButton(this.titleSprite)
    }

    enable = () => {
        Buttons.makeSpriteButton(this.titleSprite, this.titleOnClick)
        Buttons.makeSpriteButton(this.outline.invisibleSprite, this.titleOnClick)
    }

    destroy = () => {
        this.outline.destroy()
        this.titleSprite.destroy(true)
        this.active = false
    }

    private titleOnClick = () => {
        MakeAVideoStore.instance.title = this.title
        this.selected = true
        this.onClick()
    }
}
